// extracted by mini-css-extract-plugin
export var text = "index-module--text--5Zw-m";
export var title = "index-module--title--HlFPx";
export var wrapper = "index-module--wrapper--orU-f";